import { setLocaleField } from "web/Layout/Translations/LanguageWrapper";

import { Functionality } from "web/types/Employee";
import { IFunctionalityMenuItem } from "web/types/Menu";

interface IHandleFunctionalityArgs {
  menuItem: IFunctionalityMenuItem;
  functionalities?: Functionality[];
  mbActiveEnabledSelector?: boolean;
  MBActiveUrl: string;
  MBActiveUrlEn: string;
  MBActiveMenu: string;
  MBActiveMenuEn: string;
  currentLanguage: string;
  msiUrl: string;
  msiUrlEn: string;
  msiCartsEnabledSelector?: boolean;
  msMenu: string;
}

const handleFunctionality = ({
  menuItem,
  functionalities,
  mbActiveEnabledSelector,
  MBActiveUrl,
  MBActiveUrlEn,
  MBActiveMenu,
  MBActiveMenuEn,
  currentLanguage,
  msiUrl,
  msiUrlEn,
  msiCartsEnabledSelector,
  msMenu,
}: IHandleFunctionalityArgs) => {
  if (!menuItem.functionality) {
    return null;
  }

  const funcFromEmployee = functionalities?.find(
    (func) => func === menuItem.functionality
  );

  if (
    menuItem.functionality === funcFromEmployee &&
    menuItem.functionality === Functionality.ENABLE_MYBENEFIT_ACTIVE
  ) {
    return (
      mbActiveEnabledSelector &&
      MBActiveUrl && {
        ...menuItem,
        title: !MBActiveMenu
          ? menuItem.title
          : setLocaleField(currentLanguage, MBActiveMenu, MBActiveMenuEn),
        url: setLocaleField(currentLanguage, MBActiveUrl, MBActiveUrlEn),
      }
    );
  }

  if (
    menuItem.functionality === funcFromEmployee &&
    menuItem.functionality !== Functionality.ENABLE_MSI_CARDS
  ) {
    return {
      ...menuItem,
      url: setLocaleField(currentLanguage, msiUrl, msiUrlEn),
    };
  }

  if (
    menuItem.functionality === Functionality.ENABLE_MSI_CARDS &&
    msiCartsEnabledSelector
  ) {
    return {
      ...menuItem,
      url: setLocaleField(currentLanguage, msiUrl, msiUrlEn),
      title: msMenu,
    };
  }

  return null;
};

export default handleFunctionality;
